<span class="label" [ngClass]="labelType" tooltip="{{ name }}">
  {{ name }}
</span>
